import { RefObject, createContext } from 'react';

import { FormData } from '@folx-types/flow';

type formSubmissionHandler = (
	formData: FormData,
	stepKey: string,
	proceedNext?: boolean,
	parmas?: string
) => Promise<void>;

export interface IFlowContext {
	destinationFlow: string;
	existingFormData: Record<string, unknown | any>;
	handleFormSubmission: formSubmissionHandler;
	handleNavBack: (currentStepKey: string) => void;
	handleNavNext: (currentStepKey: string) => void;
	flow: string;
	flowId?: string;
	submitFormData: (data: FormData) => Promise<void>;
	handleTemporaryNavigation?: (stepKey: string, returnKey: string) => void;
	hideNavBack?: boolean;
	parentRef?: RefObject<HTMLDivElement> | null;
	appointmentData?: any;
	isPaymentWaived?: boolean; // To allow for non-sequential route skipping, we keep isPaymentWaived in the flow's context
	setIsPaymentWaived?: (isPaymentWaived: boolean) => void;
}

const FlowContext = createContext<IFlowContext>({
	destinationFlow: '',
	existingFormData: {},
	handleFormSubmission: async () => {
		return;
	},
	handleNavBack: () => {
		return;
	},
	handleNavNext: () => {
		return;
	},
	handleTemporaryNavigation: () => {
		return;
	},
	submitFormData: async () => {
		return;
	},
	flow: '',
	flowId: '',
	parentRef: null,
	isPaymentWaived: false,
	setIsPaymentWaived: () => {
		return;
	},
});

const { Provider: FlowContextProvider } = FlowContext;

export default FlowContext;
export { FlowContextProvider };
